// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2dB2N","title":"Header_title__296wu","side":"Header_side__3ZN2B"};